import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onDownload: () => void,
    onClose: () => void
}

const CardBatchDownload = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title componentClass='h4'>Download Card Batch File</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                The card batch file has been created and is available for download.  To download the file, click the download button below.
                {/* To download the batch file, <Button bsStyle='link' onClick={props.onDownload}>click here</Button> */}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onDownload}>Download</Button>
                <Button bsStyle='link' onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CardBatchDownload;